import { createSlice } from '@reduxjs/toolkit'

export const selectedProfilesPolicySimulatorSlice = createSlice({
    name: 'selectedProfilesPolicySimulator',
    initialState: {
        result: [],
    },
    reducers: {
        setSelectedProfilesPolicySimulator: (state, action) => {
            state.result = action.payload;
        }
    },
})

export const { setSelectedProfilesPolicySimulator } = selectedProfilesPolicySimulatorSlice.actions;

export const getSelectedProfilesPolicySimulator = (state) => state.selectedProfilesPolicySimulator.result;

export default selectedProfilesPolicySimulatorSlice.reducer